import { io } from 'socket.io-client';

let socket = null;

export function initializeSocket(authPayload) {
  if (socket) return socket;

  socket = io(process.env.VUE_APP_HUDDLE_SOCKET_URL, {
    auth: authPayload,
    transports: ["websocket"],
    autoConnect: true
  });

  socket.on("connect", () => console.log("🔌 Connected", socket.id));
  socket.on("disconnect", (reason) => console.log("❌ Disconnected", reason));
  socket.on("connect_error", (err) => console.error("⚠️ Connect error", err.message));

  return socket;
}

export function getSocket() {
  return socket;
}
